import { ExternalLinkIcon } from "lucide-react";

export default function RefundAndExchange() {
  return (
    <div className="sm:mt-36 p-5 mt-16 mb-16 flex flex-col gap-10">
      <h1 className="font-montserrat font-medium text-xl sm:text-2xl capitalize">
        Refund And Exchange
      </h1>
      <p className="sm:text-md text-sm">
        The following are our terms and conditions that
        constitute our exchange policy.
      </p>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Returns</h3>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - Returns are not available.
          </li>
          <li className="sm:text-md text-sm">
            - All our sales are final sales.
          </li>
        </ul>
        <p className="w-5/6 sm:text-md text-sm">
          To be eligible for a return the item must be
          damaged or defective and it must be returned
          unused and in the same condition it was received
          within 4 days of being delivered.
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Exchange</h3>
        <p className="sm:text-md text-sm">
          Exchange is accepted within 4days of delivery
        </p>
        <p className="sm:text-md text-sm">
          Exchanged items must be:
        </p>
        <ul className="gap-1 flex flex-col pl-5">
          <li className="sm:text-md text-sm">
            - Returned in an unused condition.
          </li>
          <li className="sm:text-md text-sm">
            - In the same packaging it was delivered in.
          </li>
          <li className="sm:text-md text-sm">
            - The customer is responsible for covering the
            shipping cost.
          </li>
          <li className="sm:text-md text-sm">
            - Items can only be exchanged once per order.
          </li>
        </ul>
        <p className="sm:text-md text-sm">
          Dirty and used pieces returned in a different
          packaging won't be exchanged (or refunded in case
          of defect or damage).
        </p>
      </div>
      <div className="flex flex-col gap-5">
        <h3 className="font-bold">Contact Us</h3>

        <p className="flex gap-2 flex-col pl-5">
          <a
            href="mailto:support@amadeussabra.com"
            className="hover:underline flex gap-1 w-fit items-center"
            target="_blank"
            rel="noreferrer"
          >
            <span>support@amadeussabra.com</span>
            <ExternalLinkIcon className="h-3 w-3" />
          </a>
          <a
            href="tel:+9613976780"
            className="hover:underline flex gap-1 w-fit items-center"
            target="_blank"
            rel="noreferrer"
          >
            <span>+961 3 976 780</span>
            <ExternalLinkIcon className="h-3 w-3" />
          </a>
        </p>
      </div>
    </div>
  );
}
